import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueWorkflowEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflow-edit',
	path: '/jira/settings/issues/workflows/:workflowId',
};
